<script lang="ts" setup>
defineProps<{
  modelValue?: string | number;
}>();

defineEmits(["update:modelValue"]);

const inputRef = ref<HTMLInputElement | null>(null);

defineExpose({ inputRef });
</script>

<template>
  <input
    ref="inputRef"
    class="py-4 px-10 outline-1 outline outline-[#333] outline-offset-0 rounded-full w-full md:w-80 leading-7"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<style scoped>
input::placeholder {
  overflow: visible;
}
</style>
